<template>
  <div class="section-browser">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Browser</h1>
      </div>
      <div class="section-body">
        <div class="row">
          <div v-if="browserData && !isEmpty && !isError" class="col-12 col-md-8 col-lg-12 col-xl-8">
            <DonutChart
              v-if="browserData && !isEmpty && !isError"
              :series="series"
              :labels="labels"
              :colors="colors"
              :showLegend="false"
            />
          </div>
          <div v-if="browserData && !isEmpty && !isError" class="col-12 col-md-4 col-lg-12 col-xl-4">
            <LegendContainer :percentage="series" :labels="labels" :colors="colors" />
          </div>
          <EmptyMessage v-if="!isLoading && isEmpty && !isError">
            ไม่พบข้อมูลในช่วงเวลาดังกล่าว
          </EmptyMessage>
          <EmptyMessage v-if="!isLoading && isError">
            <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
            <p>
              โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
              <a
                :href="`mailto:support@byteark.com`"
                target="_top"
              >support@byteark.com</a>
            </p>
            <span slot="code" class="code">error code : {{error.status || 'not found' }}</span>
          </EmptyMessage>
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div class="spinner-border" role="status" />
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import _ from 'lodash';
import DonutChart from '@/charts/DonutChart.vue';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import LegendContainer from '@/components/LegendContainer.vue';

export default {
  props: ['browserData', 'isLoading', 'isError', 'error'],
  components: {
    DonutChart,
    Section,
    EmptyMessage,
    LegendContainer,
  },
  data() {
    return {
      series: [],
      labels: [],
      colors: [
        '#9E2B2B',
        '#BA5950',
        '#D38479',
        '#EAAFA5',
        '#FFDAD3',
        '#ffeae7',
        '#F5E9E9',
        '#fffbfa',
      ],
    };
  },
  watch: {
    browserData() {
      this.createGraph();
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.browserData);
    },
  },
  methods: {
    async createGraph() {
      const labels = _.map(this.browserData, (value) => value.agent);
      const seriesData = _.map(
        this.browserData,
        (value) => value.playbackIdUniquePercentage,
      );
      this.series = await seriesData;
      this.labels = await labels;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.section-browser {
  .section {
    min-height: 350px;
  }
}
</style>
